import { render, staticRenderFns } from "./ButtonToggle.vue?vue&type=template&id=3a634c33&scoped=true&"
import script from "./ButtonToggle.vue?vue&type=script&lang=js&"
export * from "./ButtonToggle.vue?vue&type=script&lang=js&"
import style0 from "./ButtonToggle.vue?vue&type=style&index=0&id=3a634c33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a634c33",
  null
  
)

export default component.exports